import { Users, Globe, Clock } from 'lucide-react';

// Quiet lines for the Stage 6 flags: things to look at, not errors. An amber
// icon carries the signal; the text stays in the secondary ink.
const ICONS = { bookings: Users, online: Globe, sailing: Clock };

export default function EventFlags({ lines, style }) {
  if (!lines || !lines.length) return null;
  return (
    <ul className="ev-flags" style={style}>
      {lines.map(l => {
        const Icon = ICONS[l.kind] || Users;
        return (
          <li key={l.kind}>
            <Icon size={13} strokeWidth={2} aria-hidden="true" />
            <span>{l.text}</span>
          </li>
        );
      })}
    </ul>
  );
}
